import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface GenderParams extends DefaultHttpHeaders {
  /** Unique identifier of gender */
  genderCode: string;
}

@Injectable()
export class GenderService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining gender by code
   * Service for obtaining gender by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundGenderTypeById
   */
  gender(params: GenderParams): Observable<ParameterResult> {
    const pathParams = {
      genderCode: params.genderCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/gender/${pathParams.genderCode}`,
    });
  }
}
